import { CropTypes, SoilTypes } from 'utils/types';

import { tableTargetStatus, tableValuesPrice } from './calculationValues';

interface Props {
  cropType: CropTypes;
  soilType: SoilTypes;
  currentPh: string | undefined;
  targetPh: string | undefined;
}

export const calcCurrentPriceByCropNSoil = ({
  cropType,
  soilType,
  currentPh,
  targetPh,
}: Props): string => {
  if (!currentPh || !targetPh) {
    return '';
  }

  const isGrassland = cropType === CropTypes.Grassland;

  const pH = parseFloat(currentPh);
  const targetPhValue = parseFloat(targetPh);

  if (isNaN(pH) || isNaN(targetPhValue)) {
    return '';
  }

  const cropData =
    tableValuesPrice[isGrassland ? CropTypes.Grassland : CropTypes.OtherCrops][
      soilType
    ];

  if (!cropData) {
    return '';
  }

  const getCurrentPrice = () => {
    if (pH === targetPhValue) {
      return (cropData.equal / 10).toString();
    }

    if (pH < cropData.less.value) {
      return (cropData.less.reply / 10).toString();
    }

    if (pH > cropData.between.firstValue && pH < cropData.between.secondValue) {
      return (
        (cropData.between.firstReply * pH +
          cropData.between.secondReply) /
        10
      ).toString();
    }

    if (pH > cropData.more.value) {
      return (cropData.more.reply / 10).toString();
    }

    const { firstValue, secondValue } = cropData.default;
    const result = (firstValue * pH + secondValue) / 10;

    return result.toFixed(2);
  };

  const resultPrice = getCurrentPrice();

  const tableTargetPhValue =
    tableTargetStatus[isGrassland ? CropTypes.Grassland : CropTypes.OtherCrops][
      soilType
    ];
  const defaultTargetPh = parseFloat(tableTargetPhValue.replace(',', '.'));
  const isDefaultTargetPh = targetPhValue === defaultTargetPh;

  if (!isDefaultTargetPh) {
    const newResultPrice =
      (parseFloat(resultPrice) / (defaultTargetPh - pH)) * (targetPhValue - pH);

    return newResultPrice.toFixed(2);
  }

  return resultPrice;
};
